export const AMAZON_PALLET_DELIVERY_COLOR = '#f8991d';
